<template>
  <div
    v-if="!getVisibilityValue(visible)"
    :class="[
      {
        'row-conditional': isDynamic(visible) && conditional,
        hidden: getVisibilityValue(visible)
      },
      formatRowClass
    ]"
  >
    <slot />
  </div>
</template>

<script>
import dynamicValues from "@/mixins/dynamicValues";

export default {
  name: "FormRow",
  mixins: [dynamicValues],
  props: {
    fieldType: {
      type: String,
      required: true
    },
    conditional: {
      default: false
    },
    visible: {
      default: true
    }
  },
  computed: {
    formatRowClass() {
      return `row-${this.fieldType
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .toLowerCase()}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.row-page-heading {
  @apply pb-6;
}
.row-field-heading, 
.row-field-date-heading {
  @apply pb-2;
}
.row-form-divider {
  @apply pb-7;
}
.row-grid {
  @apply pb-8;
}
.row-fieldset-heading,
.row-radio,
.row-dropdown,
.row-field-text,
.row-field-text-confirmation,
.row-field-textarea,
.row-date,
.row-date-medicare,
.row-number,
.row-check,
.row-upload,
.row-school,
.row-form-actions,
.row-button,
.row-auth-button,
.row-paragraph,
.row-list,
.row-auth-card,
.row-three-points {
  @apply pb-6;
}
.row-conditional {
  @apply border-solid border-l-6 border-gray-500 pl-5 py-3;
}
.row-conditional:not(.hidden) + :not(.row-conditional) {
  @apply mt-6;
}
</style>
